/*
 * @Description: 
 * @Author: 长老
 * @Date: 2019-07-23 16:06:51
 * @LastEditTime: 2021-07-16 16:22:25
 * @LastEditors: duiying
 */
import axios from 'axios'
import 'url-search-params-polyfill'
import { stringify } from 'querystring';
import YunJi from '@/common/js/YunJi.js'

//微信配置
var wxJsapi = null;
var wxDefaultMsg = '你那么好看，这个分享一定要看！;听说只有长得好看的人才能看到这个分享~;【有人@你】你有一个分享尚未点击。;我看到一个好东西，你快一起看看~';
//微信jsapi请求
var jsapiAjax = null;
/**
 * 微信分享
 * @param weixinInfo 分享内容
 * @param showFlag 是否显示微信分享的按钮，“show”显示，“hide”隐藏
 */
var wxShare = (weixinInfo, showFlag) => {
  //非H5打开的页面不需要微信分享
  var appCont = YunJi.getUrlParams('appCont') || 0;
  var ua = window.navigator.userAgent.toLowerCase();
  if (appCont != 0 && ua.match(/MicroMessenger/i) != 'micromessenger') {
    return;
  }
  if (wxJsapi) {
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: wxJsapi.appId, // 必填，公众号的唯一标识
      timestamp: wxJsapi.timestamp, // 必填，生成签名的时间戳
      nonceStr: wxJsapi.nonceStr, // 必填，生成签名的随机串
      signature: wxJsapi.signature, // 必填，签名，见附录1
      openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      jsApiList: ['hideMenuItems', 'onMenuShareAppMessage', 'checkJsApi', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    });
    wx.ready(function () {
      console.log('进入隐藏微信分享按钮 ===== wx.ready')
      console.log('wx.ready okokok')
      //默认未显示所有微信的功能
      showFlag = showFlag || "show";
      //隐藏微信分享的按钮
      if (showFlag == "hide") {
        wx.hideAllNonBaseMenuItem();
      } else if (showFlag == 'hideShare') {
        wx.hideMenuItems({
          menuList: ['menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:share:facebook', 'menuItem:share:weiboApp', 'menuItem:share:QZone'],
          success: function (res) {
            //alert('已隐藏“阅读模式”，“分享到朋友圈”，“复制链接”等按钮');
          },
          fail: function (res) {
            // alert(JSON.stringify(res));
          }
        });
      } else {
        //显示所有微信功能的按钮
        wx.showAllNonBaseMenuItem();
        wx.checkJsApi({
          openTagList: ['wx-open-launch-weapp'],
          jsApiList: [
            'onMenuShareAppMessage', 'hideMenuItems'
          ]
        });
        wx.onMenuShareAppMessage({
          title: weixinInfo.title, // 分享标题
          desc: weixinInfo.content || wxDefaultMsg.split(';')[Math.floor(Math.random() * 3)], // 分享描述
          link: weixinInfo.link || window.location.href, // 分享链接
          imgUrl: weixinInfo.imgUrl, // 分享图标
          type: '', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function () {
            if (weixinInfo.callback) {
              weixinInfo.callback();
            }
            //alert('已分享');
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          }
        });
        wx.hideMenuItems({
          menuList: ['menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:share:facebook', 'menuItem:share:weiboApp', 'menuItem:share:QZone'],
          success: function (res) {
            //alert('已隐藏“阅读模式”，“分享到朋友圈”，“复制链接”等按钮');
          },
          fail: function (res) {
            // alert(JSON.stringify(res));
          }
        });
      }
      weixinInfo.configDone && weixinInfo.configDone({ type: 'success', code: 0 })
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
    });
    wx.error(function (res) {
      console.log('wx.error', res)
      weixinInfo.configDone && weixinInfo.configDone({ type: 'error', code: -2 }, res)
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
    });
  } else {
    var CURRENT_URL = window.location.host + window.location.pathname + window.location.search; //当前路径
    var protocol = window.location.protocol; //请求协议，http或https
    protocol = protocol.substring(0, protocol.length - 1);
    var params = new URLSearchParams()
    params.append('urls', CURRENT_URL)
    params.append('protocol', protocol)

    axios({
      method: "post",
      url: '//' + globalConfig.linkPath + '/yunjispecialbuyer/getWxJsapi.json',
      data: params,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then((data) => {
      if(data && data.data && data.data.data) {
        wxJsapi = data.data.data.jsapi;
      } else {
        weixinInfo.configDone && weixinInfo.configDone({ type: 'error', code: -3 })
      } 
      wxShare(weixinInfo, showFlag);
    }).catch(() => {
      weixinInfo.configDone && weixinInfo.configDone({ type: 'error', code: -1 })
    })
  }
}

export default wxShare
